const dashboardActionTypes = {
  STORE_DASHBOARD_DATA: 'STORE_DASHBOARD_DATA',
  STORE_DASHBOARD_DIAGRAM: 'STORE_DASHBOARD_DIAGRAM',
};

export default dashboardActionTypes;
